import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { BrowserRouter as Router } from "react-router-dom"
import { NavigationProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"
import ListDeals from "web/app/Deals/ListDeals"

export default class ListDealsController extends Controller {
  static values = {
    basePath: String,
    subjectType: String,
    viewGroup: Object,
    viewId: Number,
  }

  initialize() {
    global.React = React
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType={this.subjectTypeValue}
              >
                <ErrorBoundary>
                  <ListDeals rootUrl={this.basePathValue} />
                </ErrorBoundary>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
